// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Accordion, { AccordionPresentationProps } from "@insite/mobius/Accordion";
import AccordionSection from "@insite/mobius/AccordionSection";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import constants from "@store/constants";
import { tableFilterProps } from "@store/Themes/common/props/table";
import getWidgetComponent from "@toolkit/Framework/Common/Utilities/getWidgetComponent";
import * as React from "react";

const ShipmentHistorySearchTags = getWidgetComponent("ShipmentHistory/ShipmentHistorySearchTags");

const enum fields {
    isOpenByDefault = "isOpenByDefault",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.isOpenByDefault]: boolean;
    };
}

export interface ShipmentHistorySearchFormStyles {
    wrapper?: InjectableCss;
    accordion?: AccordionPresentationProps;
}

export const searchFormStyles: ShipmentHistorySearchFormStyles = {
    wrapper: tableFilterProps.wrapper,
    accordion: tableFilterProps.accordion,
};

const styles = searchFormStyles;

type Props = OwnProps;

const ShipmentHistorySearchForm: React.FunctionComponent<Props> = ({ id, fields: { isOpenByDefault } }) => {
    const [isAccordionExpanded, setIsAccordionExpanded] = React.useState(isOpenByDefault);

    const onToggleHandler = (expanded: boolean) => {
        setIsAccordionExpanded(!expanded);
    };

    return (
        <StyledWrapper {...styles.wrapper}>
            <Accordion headingLevel={2} {...styles.accordion} data-test-selector="shipmentDashboard_filtersAccordion">
                <AccordionSection
                    title={translate("Filters")}
                    expanded={isAccordionExpanded}
                    onTogglePanel={onToggleHandler}
                >
                    <Zone contentId={id} zoneName="Content" />
                </AccordionSection>
            </Accordion>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: ShipmentHistorySearchForm,
    definition: {
        group: constants.widgetGroup.shipmentHistory,
        displayName: "Search Form",
        allowedContexts: [constants.pageType.shipmentHistory],
        fieldDefinitions: [
            {
                name: fields.isOpenByDefault,
                displayName: "Make accordion open by default",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
